import { sharedCatalog } from "@shared/locales/en/US";

export const catalog = {
  ...sharedCatalog,
  GetFullscript: "Get Fullscript",
} as const;
